import styled from 'styled-components'

const StyledHomeView = styled.div`
  .page-container {
    padding: 20px;
    max-width: 600px;
    box-sizing: border-box;
    width: 100%;
    margin: 0 auto;

    .continue-game {
      background-color: ${({ theme }) => theme.color.blue[100]};
      margin: 0 0 20px 0;
      padding: 12px 12px 12px 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 6px;
      font-weight: 600;
      color: ${({ theme }) => theme.color.blue[800]};

      button {
        box-sizing: border-box;
        background-color: ${({ theme }) => theme.color.blue[600]};
        color: ${({ theme }) => theme.color.background};
        padding: 0 16px 0 14px;
        height: 42px;
        display: flex;
        font-weight: 500;
        border-radius: 6px;
        justify-content: center;
        align-items: center;
        transition: 0.2s;
        user-select: none;
        box-shadow:
          0 1px 1px hsl(0deg 0% 0% / 0.045),
          0 2px 2px hsl(0deg 0% 0% / 0.045),
          0 4px 4px hsl(0deg 0% 0% / 0.045)
        ;
  
        svg {
          height: 20px;
          margin-left: 8px;
        }
  
        &:hover {
          background-color: ${({ theme }) => theme.color.blue[700]};
        }
      }
    }

    .map-list {
      .map-group {
        .map-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .map-details-container {
            display: flex;
            align-items: center;
            user-select: none;

            .map-icon {
              height: 42px;
              width: 42px;
              position: relative;
              border-radius: 50%;
              pointer-events: none;

              img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 50%;
              }

              &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                box-shadow: inset 0 0 0 1px rgb(0, 0, 0, 0.1);
              }
            }

            .map-details {
              margin-left: 12px;

              .map-title {
                display: block;
                font-weight: 500;
                font-size: 17px;
                color: ${({ theme }) => theme.color.gray[800]};
              }

              .map-homes {
                margin-top: 1px;
                display: block;
                font-size: 15px;
                color: ${({ theme }) => theme.color.gray[500]};
              }
            }
          }

          button {
            box-sizing: border-box;
            background-color: ${({ theme }) => theme.color.blue[600]};
            color: ${({ theme }) => theme.color.background};
            padding: 0 16px 0 14px;
            height: 42px;
            display: flex;
            font-weight: 500;
            border-radius: 6px;
            justify-content: center;
            align-items: center;
            transition: 0.2s;
            user-select: none;
            box-shadow:
              0 1px 1px hsl(0deg 0% 0% / 0.045),
              0 2px 2px hsl(0deg 0% 0% / 0.045),
              0 4px 4px hsl(0deg 0% 0% / 0.045)
            ;
      
            svg {
              height: 20px;
              margin-right: 8px;
            }
      
            &:hover {
              background-color: ${({ theme }) => theme.color.blue[700]};
            }
          }
        }

        .map-games {
          display: grid;
          margin: 20px 0;
          border-radius: 6px;
          padding: 12px;
          grid-gap: 12px;
          background-color: ${({ theme }) => theme.color.gray[100]};

          .map-game {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .map-game-user-details {
              display: flex;
              align-items: center;

              .map-game-user-avatar {
                margin-right: 12px;
                display: flex;
                position: relative;
              }

              .map-game-user-stats {
                .map-game-user-username {
                  display: flex;
                  align-items: center;
                  font-weight: 500;
                  color: ${({ theme }) => theme.color.gray[700]};

                  .crown {
                    display: flex;
                    position: relative;
                    margin-left: 8px;
                    height: 19px;
                    width: 19px;

                    img {
                      position: absolute;
                      top: calc(50% - 2px);
                      left: 50%;
                      transform: translate(-50%, -50%);
                      height: 32px;
                    }
                  }
                }
                
                .map-game-user-stat {
                  display: block;
                  font-size: 13px;
                  margin-top: 1px;
                  color: ${({ theme }) => theme.color.gray[500]};
                }
              }
            }

            .map-game-user-score {
              color: ${({ theme }) => theme.color.gray[500]};
            }

            &:not(:last-child) {
              padding-bottom: 12px;
              border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};
            }
          }
        }
      }
    }
  }
`

export default StyledHomeView
